/**
 * Graphql mutation to save (or submit) Ops review decisions for Expense
 * Inventory case usage line items.
 * @module src/graphql/mutations/reviewExpenseInventory
 */
import gql from 'graphql-tag';

const REVIEW_EXPENSE_INVENTORY = gql`
  mutation reviewExpenseInventory(
    $caseId: String
    $caseExternalId: String
    $expectedCaseVersion: String
    $lineItems: [ReviewExpenseInventoryLineItem!]!
    $submit: Boolean
    $header: ExpenseInventoryHeaderInput
  ) {
    reviewExpenseInventory(
      caseId: $caseId
      caseExternalId: $caseExternalId
      expectedCaseVersion: $expectedCaseVersion
      lineItems: $lineItems
      submit: $submit
      header: $header
    ) {
      message
      externalId
      sfid
      status
    }
  }
`;

export default REVIEW_EXPENSE_INVENTORY;
